import "waypoints/lib/jquery.waypoints.min.js";

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $(".d-flex-feature").each(function () {
    $(this).waypoint({
      handler: function (direction) {
        $(this.element).addClass("active");

        this.destroy();
      },
      offset: "25%",
    });
  });

  $(".section-mission .decoration img").each(function () {
    $(this).waypoint({
      handler: function (direction) {
        $(this.element).addClass("active");

        this.destroy();
      },
      offset: "60%",
    });
  });

  $(".title-common").each(function () {
    $(this).waypoint({
      handler: function (direction) {
        $(this.element).addClass("active");

        this.destroy();
      },
      offset: "90%",
    });
  });
});
